var map = {
	"./DigitalPictogram_FACEBOOK.svg": "7b2a",
	"./DigitalPictogram_GIFT.svg": "a487",
	"./DigitalPictogram_INSTAGRAM.svg": "beca",
	"./DigitalPictogram_TWITTER.svg": "fe68",
	"./DigitalPictogram_YOUTUBE.svg": "1511"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2ec";